module.exports = __webpack_public_path__ + "static/media/box1.669a077e.webp";